module.exports = __webpack_public_path__ + "images/emoji/capricorn.1e7c1a089f85d329b981.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/capricorn.png
// module id = 3ev5
// module chunks = 13